export enum DirectionType {
    ASC = 'asc',
    DESC = 'desc',
}
